<template lang="pug">
.container(id="CreateContentEditionForm-container")
  h4 {{$t('Create New Content Edition')}}
  hr.header
  section.section-container
    section(v-if='status')
      p {{ $t('Content creation is in progress. You cannot start content creation, until current is done.') }}
    section(v-if='!status')
      p {{ $t(`All local playlists will be copied, along with their content. Created playlists will be renamed according to naming rules, and placed in local playlists, with time restriction set here.`) }}
      p {{ $t(`Operation may take long time, depending on size of your network and content complexity. You can proceed to work with Wave, created content will be visible when process is done. You may follow progress below at any time, by reopening this form.`) }}
      hr.header
      section.center
        p {{$t('Please provide rename rules for copies of container media that will be created. You must provide at least 3 characters for both inputs. Media not fulfilling the "search for" input will be omitted.')}}
        el-input.el-input(
          id="CreateContentEdition-searchString",
          ref='searchString',
          v-model='searchString',
          type="text",
          style="width: 200px;",
          :placeholder='$t("search for")',
        )
        span &nbsp;
        font-awesome-icon.linker-icon(icon="arrow-right")
        span &nbsp;
        el-input.el-input(
          id="CreateContentEdition-replaceString",
          ref='replaceString',
          v-model='replaceString',
          type="text",
          style="width: 200px",
          :placeholder='$t("replace with")',
        )
      section.center
        p {{$t('Choose moment screens will switch to playing new content. Current content will have "stop" date, and new content "start" date adjusted accordingly.')}}
        el-date-picker(:picker-options="{ firstDayOfWeek: 1 }", v-model="changeMoment", type="datetime", format='yyyy-MM-dd HH:mm', :placeholder="$t('Moment of content change')", id='CreateEdition-datePickerChange')
    .create-button-row
      el-button(id="CreateContentEditionForm-CreateButton", style='width: 100%;' :type="status ? 'warning' : 'success'", @click='submitCreate', :disabled = '!dataValid && !status')
        span(v-if='status && status.i !== status.length') {{ $t('Done ') + status.i + $t(' of ') + status.length + ' - ' + status.name }} &nbsp;
          font-awesome-icon.fa-pulse(icon="spinner")
        span(v-if='status && status.i === status.length') {{ $t('Done creating content edition. Reload browser.') }} &nbsp;
          font-awesome-icon(icon="retweet")
        span(v-if='!status') {{ $t('Create content edition') }} &nbsp;
          font-awesome-icon(v-if='!status', icon="exchange-alt")
  </template>

<script>
import Vue from 'vue'
import testUtils from '../Common/textUtils.mixin'

export default {
  mixins: [testUtils],
  async created () {
    Vue.$io.socket.off('Create_Content_Edition_Progress')
    Vue.$io.socket.on('Create_Content_Edition_Progress', data => {
      this.status = data
    })
  },
  data () {
    return {
      file: null,
      errors: [],
      searchString: '',
      replaceString: '',
      changeMoment: undefined,
      status: undefined
    }
  },
  watch: {
    params: async function (newParams, oldParams) {
    }
  },
  methods: {
    async submitCreate () {
      if (this.status && this.status.i === this.status.length) window.location.reload()
      if (this.status) return
      await Vue.axios.post('medium/createNewContentEdition', {
        searchString: this.searchString,
        replaceString: this.replaceString,
        changeMoment: this.changeMoment
      })
        .then(response => {
          return response.data
        })
    }
  },
  computed: {
    dataValid () {
      return this.searchString.length >= 3 && this.replaceString.length >= 3 && this.changeMoment
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.create-button-row {
  margin-top: 50px;
  .fa-pulse {
    color: white;
  }
}
.section-container {
  margin-left: 50%;
  width: 500px;
  transform: translate(-250px, 0px);;
}
.existing-extension-section {
  display: flex;
  align-items: center;
  flex-direction: column;
  .advice {
    color: $--color-text-secondary;
  }
  .existing-extension-row {
    display: flex;
    min-height: 30px;
    align-items: center;
    border-bottom: $--border-light;
    &.isSelected {
      background-color: $--background-color-selected;
    }
    .cell {
      font-size: $--font-size-base;
      padding: 10px;
      &.header {
        color: $--color-text-secondary;
      }
      &.name {
        width: 160px;
      }
      &.description {
        width: 750px;
      }
      &.version {
        width: 50px;
      }
      &.global {
        width: 150px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/CreateContentEdition.vue